export type HeaderSubItem = {
  label: string;
  path: string;
};

export type HeaderNavigationItem = {
  label: string;
  path: string;
  isURL?: boolean;
  subItems?: HeaderSubItem[];
};

export type SocialInfo = {
  name: string;
  url: string;
  icon: string;
};

export type SponsorInfo = {
  imageUrl: string;
  websiteUrl: string;
};

export type SiteContent = {
  HELMET: {
    title: string;
    description: string;
    imageUrl: string;
  };
  LOGO: {
    white: string;
    black: string;
  };
  SOCIAL_URLS: SocialInfo[];
  HEADER_NAVIGATION_ITEMS: HeaderNavigationItem[];
  FOOTER: {
    location: string;
    contactEmail: string;
    copywrite: string;
  };
  SPONSORS_OLD: SponsorInfo[];
};

const CONTENT: SiteContent = {
  HELMET: {
    title: 'Armada JS 2024 - Full-stack JavaScript Conference',
    description:
      'Full-stack JavaScript conference happening in Novi Sad, Serbia, 5th-6th December. Meet and talk with some of the best JavaScript developers and speakers coming from all over the world to Novi Sad.',
    imageUrl: 'https://armada-js.com/images/link-preview.png?32'
  },
  LOGO: {
    white: '/images/logo-name.png',
    black: '/images/logo-name.png'
  },
  SOCIAL_URLS: [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/armadajs',
      icon: 'facebook-f'
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/armada_js',
      icon: 'twitter'
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/armada-js',
      icon: 'linkedin'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/armada_js_conference/',
      icon: 'instagram'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/channel/UCA6ud5QOdvA_ajOBqwOsELg',
      icon: 'youtube'
    }
  ],
  FOOTER: {
    location: 'Cinestar Big 4DX, Novi Sad',
    contactEmail: 'contact@armada-js.com',
    copywrite: '© 2024 Armada JS. All Rights Reserved.'
  },
  HEADER_NAVIGATION_ITEMS: [
    {
      path: '/armada-schedule-2024-v1.pdf',
      label: 'Schedule',
      isURL: true
    },
    {
      path: '/#speakers',
      label: 'Speakers'
    },
    // {
    //   path: '/meetups',
    //   label: 'Meetups'
    // },
    {
      path: '/workshop',
      label: 'Workshop'
    },
    {
      path: '/sponsors',
      label: 'Sponsors'
    },
    // {
    //   path: '/2019',
    //   label: '2019'
    // },
    {
      path: '/',
      label: 'Past editions',
      subItems: [
        {
          path: '/2019',
          label: '2019'
        },
        {
          path: '/2022',
          label: '2022'
        },
        {
          path: '/2023',
          label: '2023'
        }
      ]
    },
    // {
    //   path: '/call-for-papers',
    //   label: 'Call for papers'
    // },
    {
      path: '/code-of-conduct',
      label: 'Code of conduct'
    },
    {
      path: '/contact',
      label: 'Contact'
    },
    {
      path: '/tickets',
      label: 'Tickets'
    }
  ],
  SPONSORS_OLD: [
    {
      imageUrl: 'sponsors-old/bosch-logo.png',
      websiteUrl: 'https://www.bosch.rs/'
    },
    {
      imageUrl: 'sponsors-old/fsq-logo.png',
      websiteUrl: 'https://location.foursquare.com/company/careers/view-all/#engineering'
    },
    {
      imageUrl: 'sponsors-old/nabis-logo.png',
      websiteUrl: 'https://www.nabis.com/'
    },
    {
      imageUrl: 'sponsors-old/nx.png',
      websiteUrl: 'https://nx.dev'
    },
    {
      imageUrl: 'sponsors-old/netokracija-logo.png',
      websiteUrl: 'https://www.netokracija.rs/'
    },
    {
      imageUrl: 'sponsors-old/shiftmag-logo.png',
      websiteUrl: 'https://shiftmag.dev/'
    },
    {
      imageUrl: 'sponsors-old/push-based-logo.png',
      websiteUrl: 'https://push-based.io/'
    },
    {
      imageUrl: 'sponsors-old/gitnation-logo.png',
      websiteUrl: 'https://gitnation.org/'
    },
    {
      imageUrl: 'sponsors-old/sentry-logo.png',
      websiteUrl: 'https://sentry.io/'
    },
    {
      imageUrl: 'sponsors-old/sevenbridges-logo.png',
      websiteUrl: 'https://www.sevenbridges.com/'
    },
    {
      imageUrl: 'sponsors-old/prodyna-logo.png',
      websiteUrl: 'https://www.prodyna.com/en/'
    },
    {
      imageUrl: 'sponsors-old/epam-logo.png',
      websiteUrl: 'https://www.epam.com/careers/epam-serbia'
    },
    {
      imageUrl: 'sponsors-old/brame-logo.png',
      websiteUrl: 'https://brame.ch/'
    },
    {
      imageUrl: 'sponsors-old/yettel-logo.png',
      websiteUrl: 'https://www.yettel.rs/'
    },
    {
      imageUrl: 'sponsors-old/luxoft-logo.png',
      websiteUrl: 'https://career.luxoft.com/'
    },
    {
      imageUrl: 'sponsors-old/endava-logo.png',
      websiteUrl:
        'https://s.bl-1.com/h/drhdlrhv?url=https://careers.endava.com/en/Search-Job?region=Central%20Europe&locations=Belgrade,Cacak,Kragujevac,Nis,Novi%20Sad'
    },
    {
      imageUrl: 'sponsors-old/tx-logo.png',
      websiteUrl: 'https://tx.group/en/'
    },
    {
      imageUrl: 'sponsors-old/united-cloud-logo.png',
      websiteUrl: 'https://united.cloud/'
    },
    {
      imageUrl: 'sponsors-old/storyblok-logo.png',
      websiteUrl: 'https://www.storyblok.com/'
    },
    {
      imageUrl: 'sponsors-old/servalit-logo.png',
      websiteUrl: 'https://servalit.com/'
    },
    {
      imageUrl: 'sponsors-old/ava-logo.png',
      websiteUrl: 'https://ava.info/'
    },
    {
      imageUrl: 'sponsors-old/comdata-logo.png',
      websiteUrl: 'https://www.comdata.rs/en/'
    },
    {
      imageUrl: 'sponsors-old/ibm-logo.png',
      websiteUrl: 'https://www.ibm.com/'
    },
    {
      imageUrl: 'sponsors-old/telenor-logo.png',
      websiteUrl: 'https://www.telenor.rs/'
    },
    {
      imageUrl: 'sponsors-old/mozilla-logo.png',
      websiteUrl: 'https://www.mozilla.org/'
    },
    {
      imageUrl: 'sponsors-old/adeva-logo.png',
      websiteUrl: 'https://adevait.com/'
    },
    {
      imageUrl: 'sponsors-old/simplygrow-logo.png',
      websiteUrl: 'https://simplygrow.co/'
    },
    {
      imageUrl: 'sponsors-old/manning-logo.png',
      websiteUrl: 'https://www.manning.com/'
    },
    {
      imageUrl: 'sponsors-old/exlrt-logo.png',
      websiteUrl: 'https://www.exlrt.com/'
    },
    {
      imageUrl: 'sponsors-old/eryce-logo.png',
      websiteUrl: 'https://eryce.com/'
    },
    {
      imageUrl: 'sponsors-old/oreilly-logo.png',
      websiteUrl: 'https://www.oreilly.com/pub/cpc/224555'
    },
    {
      imageUrl: 'sponsors-old/sketch-logo.png',
      websiteUrl: 'https://www.sketch.com/'
    },
    {
      imageUrl: 'sponsors-old/vivify-logo.png',
      websiteUrl: 'https://www.vivifyideas.com/'
    },
    {
      imageUrl: 'sponsors-old/purezeen-logo.png',
      websiteUrl: 'http://www.purezeen.rs/'
    },
    {
      imageUrl: 'sponsors-old/vinum-logo.png',
      websiteUrl: 'https://www.vinum.rs/'
    },
    {
      imageUrl: 'sponsors-old/razbeerbriga-logo.png',
      websiteUrl: 'https://razbeerbriga.rs/'
    },
    {
      imageUrl: 'sponsors-old/chipsy-logo.png',
      websiteUrl: 'https://chipsy.rs/'
    },
    {
      imageUrl: 'sponsors-old/gud-logo.jpeg',
      websiteUrl: 'https://www.facebook.com/MarboGUD/'
    }
  ]
};

export default CONTENT;
